<template>
  <badge :type="getBadgeType()">
    {{ $t(`ESTABLISHMENT_INTERNAL_ORDERS.STATUS_${order.status}`) }}
  </badge>
</template>

<script>
import {
  ESTABLISHMENT_INTERNAL_ORDER_STATUS_DRAFT,
  ESTABLISHMENT_INTERNAL_ORDER_STATUS_SUBMITTED,
  ESTABLISHMENT_INTERNAL_ORDER_STATUS_CONFIRMED,
  ESTABLISHMENT_INTERNAL_ORDER_STATUS_PARTIALLY_INVOICED,
  ESTABLISHMENT_INTERNAL_ORDER_STATUS_COMPLETED,
  ESTABLISHMENT_INTERNAL_ORDER_STATUS_REJECTED,
  ESTABLISHMENT_INTERNAL_ORDER_STATUS_CANCELED,
} from "@/constants/establishmentInternalOrders";

export default {
  name: "establishment-internal-order-status-badge",
  props: {
    order: {
      type: Object,
      required: true,
    },
  },
  methods: {
    getBadgeType() {
      switch (this.order.status) {
        case ESTABLISHMENT_INTERNAL_ORDER_STATUS_DRAFT:
          return "primary";
        case ESTABLISHMENT_INTERNAL_ORDER_STATUS_SUBMITTED:
          return "info";
        case ESTABLISHMENT_INTERNAL_ORDER_STATUS_CONFIRMED:
          return "success";
        case ESTABLISHMENT_INTERNAL_ORDER_STATUS_PARTIALLY_INVOICED:
          return "info";
        case ESTABLISHMENT_INTERNAL_ORDER_STATUS_COMPLETED:
          return "success";
        case ESTABLISHMENT_INTERNAL_ORDER_STATUS_REJECTED:
          return "warning";
        case ESTABLISHMENT_INTERNAL_ORDER_STATUS_CANCELED:
          return "danger";
        default:
          return "default";
      }
    },
  },
};
</script>
